import { render, staticRenderFns } from "./sliderGoods.module.vue?vue&type=template&id=502ebeae&scoped=true"
import script from "./sliderGoods.module.vue?vue&type=script&lang=js"
export * from "./sliderGoods.module.vue?vue&type=script&lang=js"
import style0 from "./sliderGoods.module.vue?vue&type=style&index=0&id=502ebeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ebeae",
  null
  
)

export default component.exports